export default "__VITE_ASSET__NYnTvPiV__"